// extracted by mini-css-extract-plugin
export default {"nav-icon":"Hamburger_nav-icon__O8wK5","open":"Hamburger_open__UZwms"};